import * as Backbone from 'backbone'
import { format } from './declination-helper'

/**
 * Обработка непредвиденных ошибок валидации
 * @param {Array} errorsList Список ошибок
 * @param {string} where Где возникла проблема (для вывода в сообщения об ошибках)
 */
export const globalValidationError = (errorsList, where) => {
  let globalError = where + ' ' +
    format(errorsList.length, ['произошла', 'произошли', 'произошли']) + ' ' +
    format(errorsList.length, ['ошибка', 'ошибки', 'ошибки']) + ':'
  errorsList.forEach((error, index) => {
    globalError += ' «' + error.message + '»'
    if (index < errorsList.length - 1) {
      globalError += ','
    }
    let err = new RangeError(where + ' произошла непредвиденная ошибка валидации поля ' + error.field + ': ' + error.message)
    if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
      Raven.captureException(err)
    }
  })
  globalError += '.'
  Backbone.trigger('global-error', { error: globalError })
}
